module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Attract</h1>\n</div>\n<iframe src=\"apps/attract/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/attract/attract.component.html
// module id = ../../../../../src/app/pages/attract/attract.component.html
// module chunks = main